import { request } from './client.js';

export async function getUsers() {
  const data = await request('/api/users', { method: 'GET' });
  return data.users || [];
}

export async function addUser(userData) {
  return await request('/api/users', {
    method: 'POST',
    body: JSON.stringify(userData),
  });
}

export async function updateUser(id, updates) {
  return await request(`/api/users/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(updates),
  });
}

export async function deleteUser(id) {
  return await request(`/api/users/${id}`, {
    method: 'DELETE',
  });
}
